/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  LoggerDataType,
} from '..';

import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface GetLoggerDataInput {
  id?: string;
}
const build = (_query: DocumentNode, input: GetLoggerDataInput, name = 'QueryResult') => {
  const bQuery = `
  query ${ name }(`+
    ( input.id !== undefined ? `$id: String = ${JSON.stringify(input.id).replace(/"(\w+)":/g, '$1:')}` : '' ) + `){
    getLoggerData(
      ${ input.id !== undefined ? 'id: $id,' : '' }
    ){
      ...loggerdatatype
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class GetLoggerDataQuery {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment loggerdatatype on LoggerDataType { ... }
   */
  async execute(_query: DocumentNode, input: GetLoggerDataInput, refresh = false) {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    const fetchPolicy = refresh ? 'network-only' : 'cache-first';
   return await client?.query<{ getLoggerData: Partial<LoggerDataType> }>({ query: build(_query, input), fetchPolicy });
  }
}
